import { COLORS } from '@/theme';
import styled from 'styled-components';
import { ImportStatusEnum } from '@/models/productsImport.model';

export const StyledBadgeWrapper = styled.div`
  width: 8.5rem;
`;

export const StyledBadge = styled.div<{ $status?: ImportStatusEnum }>`
  display: flex;
  justify-content: center;
  align-items: center;
  width: fit-content;
  padding: 0.25rem 0.75rem;
  height: 1.5rem;
  gap: 0.5rem;
  border-radius: 1.6rem;
  border: 1px solid ${COLORS.BRIGHT_GRAY};
  background: ${COLORS.GRAY};

  .indicator {
    border-radius: 50%;
    height: 0.75rem;
    width: 0.75rem;
    background: ${({ $status }) => {
      switch ($status) {
        case ImportStatusEnum.FAILED:
          return COLORS.RED;
        case ImportStatusEnum.PROCESSING:
          return COLORS.ORANGE;
        case ImportStatusEnum.FINISHED:
          return COLORS.GREEN;
      }
    }};
  }
`;

export const StyledProgressCell = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  min-width: 8rem;

  .ant-progress {
    margin: 0;
    line-height: 1;
  }

  span {
    color: ${COLORS.BLACK};
    white-space: nowrap;
  }
`;

export const StyledDownloadButton = styled.a`
  display: flex;
  justify-content: center;
  align-items: center;
  width: fit-content;
  border-radius: 0.25rem;
  padding: 0.25rem 0.75rem;
  height: 2.75rem;
  gap: 0.5rem;
  color: ${COLORS.BLACK};
  background: ${COLORS.LIGHT_GRAY_2};

  &:hover {
    color: ${COLORS.BLACK};
  }
`;
